import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { NotifyService } from "./shared";

@Injectable()
export class HelperService {
  constructor() {
  }

  public ExtractErrorMessage(error: Response | any): string {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string = "";
    if (error instanceof Response) {
      const body: any = error.json() || '';
      if (body instanceof Object) {
        if (body.Messages) {
          body.Messages.forEach((msg: any) => {
            errMsg += msg.Text + '\r\n';
          });
        } else if (body.Message) {
          errMsg = body.Message ? body.Message : body.toString();
        }
      } else {
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      }
    } else {
      errMsg = error.Message ? error.Message : error.toString();
    }
    return errMsg;
  }
}

export class KeyValuePair {
  public constructor(public Key: string, public DisplayName: string) {
  }
}

export class DialogData {
  ButtonOk: string;
  ButtonNo: string;
  HeaderMessage: string;

  Params: any;

  public constructor(header, buttonOk, buttonNo, params) {
    this.ButtonOk = buttonOk;
    this.ButtonNo = buttonNo;
    this.HeaderMessage = header;
    this.Params = params;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helper.service.ts